//import Font Awesome

import Vue from 'vue';
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// SOLID STYLE
import {
    faAdjust,
    faBan,
    faBars,
    faBomb,
    faBug,
    faCheckSquare,
    faChevronLeft,
    faChevronRight,
    faCode,
    faCog,
    faComment,
    faCouch,
    faDoorClosed,
    faDoorOpen,
    faEdit,
    faEnvelope,
    faEnvelopeOpenText,
    faExclamationTriangle,
    faFont,
    faHeart,
    faLightbulb,
    faLock,
    faLockOpen,
    faMapMarkerAlt,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faShoppingCart,
    faSlidersH,
    faSquare,
    faTimes,
    faQuestionCircle,
    faTrash,

} from '@fortawesome/free-solid-svg-icons'

// REGULAR STYLE
import {
    faSquare as faSquareRegular,
    faTimesCircle,

} from '@fortawesome/free-regular-svg-icons'

// BRANDS
import {
    faFacebookSquare,
    faInstagram,
    faLinkedin,
    faSpotify,
    faTwitterSquare,
    faYoutubeSquare,

} from '@fortawesome/free-brands-svg-icons'

library.add(
    // solid style
    faAdjust,
    faBan,
    faBars,
    faBomb,
    faBug,
    faCheckSquare,
    faChevronLeft,
    faChevronRight,
    faCode,
    faCog,
    faComment,
    faCouch,
    faDoorClosed,
    faDoorOpen,
    faEdit,
    faEnvelope,
    faEnvelopeOpenText,
    faExclamationTriangle,
    faHeart,
    faFont,
    faLightbulb,
    faLock,
    faLockOpen,
    faMapMarkerAlt,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faShoppingCart,
    faSlidersH,
    faSquare,
    faTimes,
    faQuestionCircle,
    faTrash,

    // regular style
    faTimesCircle,
    faSquareRegular,

    // brands
    faFacebookSquare,
    faInstagram,
    faLinkedin,
    faSpotify,
    faTwitterSquare,
    faYoutubeSquare,
)

dom.watch();
Vue.component('font-awesome-icon', FontAwesomeIcon)